import { useI18n } from "@/context/I18nContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Globe } from "lucide-react";

export function LanguageSwitcher({ compact = false, testid = "language-switcher" }) {
  const { lang, setLang, languages } = useI18n();
  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger data-testid={testid} className={compact ? "h-9 w-[130px] rounded-full text-sm" : "rounded-full"}>
        <div className="flex items-center gap-2 min-w-0">
          <Globe className="h-4 w-4 flex-shrink-0 text-muted-foreground" strokeWidth={1.5} />
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {languages.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>{l.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
